"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRenalAnaemiaHematology = createRenalAnaemiaHematology;
const renalAnaemiaHematology_1 = require("../../../forms/ktx/transplantation-screening/medical-history/renalAnaemiaHematology");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const utils_1 = require("../../../events/utils");
const messages = {
    title: {
        id: "ktx.dashboard.renal_anaemia_hematology",
        defaultMessage: "Renális anaemia - hematológia"
    }
};
const allMessages = {
    ...renalAnaemiaHematology_1.renalAnaemiaHematologyTypeMessages,
    ...renalAnaemiaHematology_1.anaemiaTypeMessages,
    ...renalAnaemiaHematology_1.hasDiseaseMessages
};
function createRenalAnaemiaHematology(intl, { events }) {
    const { formatMessageMap, formatDate } = intl;
    const relevantEvents = (0, utils_1.findEventsByQuery)(events, queries_1.medicalHistoryQueries.renalAnaemiaHematology);
    const list = relevantEvents
        .map(event => {
        const { timestamp, origin } = event;
        const formattedTimestamp = formatDate(timestamp, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
        const items = [];
        items.push({
            type: "list-item",
            value: formatMessageMap(allMessages, event.value)
        });
        return {
            type: "list",
            attachments: (0, utils_1.mapEventsToAttachments)(event),
            timestamp: event.timestamp,
            label: formattedTimestamp,
            origin,
            items
        };
    })
        .sort(shared_1.compareByTimestamp);
    const content = (0, shared_1.createGroupContent)(list);
    return (0, shared_1.createGroup)(intl, { label: messages.title, content });
}
